// extracted by mini-css-extract-plugin
export default {"amazonPayModeSection":"O2-z"};